




























import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { ValidationProvider, extend, ValidationObserver } from "vee-validate";
import { required, confirmed } from "vee-validate/dist/rules";
import format from 'date-fns/format'
extend("required", {
  ...required,
  message: "Vui lòng điền đầy đủ thông tin!"
})
export default Vue.extend({
  name: "CloseDate",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  computed: {
    ...mapGetters({
      showCloseDateModal: "productCampaign/showCloseDateModal"
    })
  },
  methods: {
    dateFormatter(date) {
      return format(date, 'dd-MM-yyyy')
    },
    handleCancel() {
      this.setCloseDateModal(false);
    },
    async handleCloseDate() {
      const payload = await this.closeDate(this.date);
    },
    ...mapMutations({
      setCloseDateModal: "productCampaign/setCloseDateModal"
    }),
    ...mapActions({
      closeDate: "productCampaign/closeDate"
    })
  },
  data() {
    return {
      date: new Date()
    };
  }
});
